(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lonaro-ugc-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lonaro-ugc-reviews')) {
    customElements.define('lonaro-ugc-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.bootTimer || this.controller) return;
        this.bootTimer = setTimeout(() => { this.bootTimer = null; this.init(); }, 0);
      }
      init() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.controller = new AbortController();
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.originalCards = this.cards.slice();
        this.infinite = this.dataset.infinite !== 'false' && this.originalCards.length > 1;
        this.cloneSerial = 0;
        this.boundVideos = new WeakSet();
        this.boundReadMore = new WeakSet();
        this.videos = Array.from(this.querySelectorAll('video'));
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.dots = this.querySelector('[data-dots]');
        this.counter = this.querySelector('[data-counter]');
        this.rtl = this.getAttribute('dir') === 'rtl';
        this.mediaQuery = matchMedia('(prefers-reduced-motion: reduce)');
        this.motionPaused = this.mediaQuery.matches;
        this.autoSuspended = false;
        this.hold = null;
        this.activePointerId = null;
        this.inView = false;
        this.visibleVideos = new Set();
        this.manualPaused = new Set();
        this.manualPlaying = new Set();
        this.positions = [0];
        this.ensureLoopCapacity();
        this.classList.add('is-ready');
        this.listen(this.prev, 'click', () => this.navigate(-1));
        this.listen(this.next, 'click', () => this.navigate(1));
        this.listen(this.track, 'scroll', () => {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            const offset = Math.abs(this.track.scrollLeft);
            const max = this.track.scrollWidth - this.track.clientWidth;
            if (this.infinite && (offset < this.step || offset > max - this.step)) this.measure();
            this.updateNavigation();
          });
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => { if (!this.pointerDown) this.measure(); }, 180);
        });
        this.listen(this.track, 'scrollend', () => { if (!this.pointerDown) this.measure(); });
        this.listen(this.track, 'pointerdown', event => {
          if (event.isPrimary === false || (event.pointerType === 'mouse' && event.button !== 0)) return;
          this.activePointerId = event.pointerId;
          this.pointerDown = true;
          if (!this.beginHold(event)) this.autoSuspended = true;
          if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, a, input, [data-review], [data-read-more]')) return;
          this.drag = { id: event.pointerId, startX: event.clientX, lastX: event.clientX, moved: false };
        });
        this.listen(window, 'pointermove', event => {
          if (this.hold && event.pointerId === this.hold.pointerId && Math.hypot(event.clientX - this.hold.x, event.clientY - this.hold.y) > 8) {
            this.releaseHold(true, false);
            this.autoSuspended = true;
          }
          if (!this.drag || event.pointerId !== this.drag.id) return;
          if (!this.drag.moved && Math.abs(event.clientX - this.drag.startX) < 5) return;
          if (!this.drag.moved) {
            this.releaseHold(true, false);
            this.autoSuspended = true;
            this.drag.moved = true;
            this.track.classList.add('is-dragging');
            this.track.setPointerCapture(event.pointerId);
          }
          event.preventDefault();
          this.track.scrollLeft -= event.clientX - this.drag.lastX;
          this.drag.lastX = event.clientX;
          if (this.infinite) this.measure();
        }, { passive: false });
        const endPointer = event => {
          if (event.pointerId !== undefined && this.activePointerId !== null && event.pointerId !== this.activePointerId) return;
          this.releaseHold(!document.hidden, event.type !== 'pointercancel');
          this.activePointerId = null;
          this.pointerDown = false;
          if (this.drag && (event.pointerId === undefined || event.pointerId === this.drag.id)) {
            const moved = this.drag.moved;
            this.drag = null;
            this.track.classList.remove('is-dragging');
            if (moved) {
              this.ignoreClickUntil = performance.now() + 300;
              this.measure(); this.goTo(this.currentIndex());
            }
          }
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => this.measure(), 180);
        };
        this.listen(window, 'pointerup', endPointer);
        this.listen(window, 'pointercancel', endPointer);
        this.listen(window, 'blur', endPointer);
        this.listen(this.track, 'lostpointercapture', endPointer);
        this.listen(this.track, 'dragstart', event => event.preventDefault());
        this.listen(this.track, 'contextmenu', event => {
          const card = event.target.closest('[data-card]');
          if (card && card.querySelector('video') && !event.target.closest('a, button')) event.preventDefault();
        });
        this.listen(this.track, 'click', event => {
          if (performance.now() < (this.ignoreClickUntil || 0)) { event.preventDefault(); event.stopPropagation(); }
        }, { capture: true });
        this.listen(this.track, 'wheel', () => { this.autoSuspended = true; }, { passive: true });
        this.listen(this, 'focusin', () => { this.autoSuspended = true; });
        this.listen(this.track, 'keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === ' ') {
            event.preventDefault();
            if (!event.repeat) {
              this.motionPaused = !this.motionPaused;
              if (!this.motionPaused) this.autoSuspended = false;
              this.manualPlaying.clear(); this.syncVideos();
            }
          } else if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.navigate((event.key === 'ArrowRight' ? 1 : -1) * (this.rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault(); this.autoSuspended = true;
            const card = event.key === 'Home' ? this.originalCards[0] : this.originalCards[this.originalCards.length - 1];
            this.goTo(this.cards.indexOf(card));
          }
        });
        this.listen(this.dots, 'click', event => {
          const dot = event.target.closest('[data-page]');
          if (dot) { this.autoSuspended = true; this.goTo(Number(dot.dataset.page)); }
        });
        this.listen(this.mediaQuery, 'change', event => {
          if (event.matches) { this.motionPaused = true; this.manualPlaying.clear(); }
          this.syncVideos();
        });
        this.listen(document, 'visibilitychange', () => {
          if (document.hidden) endPointer({ type: 'visibilitychange' });
          this.syncVideos();
        });
        this.bindCardControls();
        this.listen(document, 'shopify:block:select', event => {
          const card = this.originalCards.find(item => item.dataset.blockId === event.detail.blockId);
          if (!card) return;
          this.autoSuspended = true;
          const r = this.track.getBoundingClientRect(), c = card.getBoundingClientRect();
          const offset = this.rtl ? r.right - c.right : c.left - r.left;
          this.track.scrollBy({ left: this.rtl ? -offset : offset, behavior: 'auto' });
        });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.target === this) this.inView = entry.isIntersecting;
              else if (entry.isIntersecting && entry.intersectionRatio >= .35) this.visibleVideos.add(entry.target);
              else { this.visibleVideos.delete(entry.target); entry.target.muted = true; }
            });
            this.syncVideos();
          }, { threshold: [0, .35] });
          this.observer.observe(this);
          this.videos.forEach(video => this.observer.observe(video));
        }
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.measure());
          this.resizeObserver.observe(this.track);
        } else { this.listen(window, 'resize', () => this.measure()); }
        this.measure();
        if (document.fonts) document.fonts.ready.then(() => { if (this.controller) this.measure(); });
        if (this.dataset.autoscroll === 'true') {
          this.timer = setInterval(() => {
            if (!this.inView || document.hidden || this.motionPaused || this.hold || this.pointerDown || this.autoSuspended || this.positions.length < 2 || (window.Shopify && Shopify.designMode)) return;
            this.measure();
            this.goTo(this.infinite ? this.currentIndex() + 1 : (this.currentIndex() + 1) % this.positions.length);
          }, Math.max(3000, Number(this.dataset.delay) || 5000));
        }
      }
      listen(target, type, handler, options = {}) {
        if (target) target.addEventListener(type, handler, { ...options, signal: this.controller.signal });
      }
      beginHold(event) {
        if (this.hold || event.target.closest('button, a, input, select, textarea')) return false;
        const card = event.target.closest('[data-card]');
        const video = card && card.querySelector('video');
        if (!video) return false;
        const automatic = this.dataset.autoplay === 'true' && !this.motionPaused && !this.manualPaused.has(video);
        this.hold = {
          pointerId: event.pointerId, x: event.clientX, y: event.clientY,
          card, video, resume: !video.ended && (!video.paused || this.manualPlaying.has(video) || automatic),
          autoSuspended: this.autoSuspended
        };
        this.autoSuspended = true;
        card.classList.add('is-holding');
        video.pause();
        return true;
      }
      releaseHold(resumePlayback = true, restoreAuto = true) {
        if (!this.hold) return;
        const held = this.hold;
        this.hold = null;
        held.card.classList.remove('is-holding');
        if (restoreAuto) this.autoSuspended = held.autoSuspended;
        const visible = this.visibleVideos.has(held.video) || !this.observer;
        const allowed = !this.manualPaused.has(held.video) && (!this.motionPaused || this.manualPlaying.has(held.video));
        if (resumePlayback && held.resume && !document.hidden && visible && allowed) this.playVideo(held.video);
      }
      bindCardControls() {
        this.querySelectorAll('[data-read-more]').forEach(button => {
          if (this.boundReadMore.has(button)) return;
          this.boundReadMore.add(button);
          this.listen(button, 'click', () => {
            const text = button.parentElement.querySelector('[data-review]');
            const expanded = button.getAttribute('aria-expanded') !== 'true';
            text.classList.toggle('is-expanded', expanded);
            button.setAttribute('aria-expanded', String(expanded));
            button.textContent = expanded ? 'הצג פחות' : 'קראו עוד';
            this.autoSuspended = true;
          });
        });
        this.videos = Array.from(this.querySelectorAll('video'));
        this.videos.forEach(video => {
          if (this.boundVideos.has(video)) return;
          this.boundVideos.add(video);
          video.muted = true; video.defaultMuted = true;
          const card = video.closest('[data-card]');
          const playButton = card.querySelector('[data-video-toggle]');
          const soundButton = card.querySelector('[data-sound-toggle]');
          this.listen(playButton, 'click', () => {
            if (video.paused) {
              this.manualPaused.delete(video); this.manualPlaying.add(video); this.playVideo(video);
            } else { this.manualPaused.add(video); this.manualPlaying.delete(video); video.pause(); }
          });
          this.listen(soundButton, 'click', () => {
            const unmute = video.muted;
            this.videos.forEach(other => { other.muted = true; });
            video.muted = !unmute;
            if (unmute) { this.manualPaused.delete(video); this.manualPlaying.add(video); this.playVideo(video); }
          });
          const update = () => {
            if (this.hold && this.hold.video === video && !video.paused) video.pause();
            playButton.setAttribute('aria-pressed', String(!video.paused));
            playButton.setAttribute('aria-label', video.paused ? 'ניגון הסרטון' : 'השהיית הסרטון');
          };
          update();
          if (soundButton) {
            soundButton.setAttribute('aria-pressed', 'false');
            soundButton.setAttribute('aria-label', 'הפעלת קול');
          }
          this.listen(video, 'play', update); this.listen(video, 'pause', update);
          this.listen(video, 'ended', () => { this.manualPlaying.delete(video); this.manualPaused.add(video); update(); });
          this.listen(video, 'volumechange', () => {
            if (this.dataset.sound !== 'true' && !video.muted) video.muted = true;
            if (soundButton) {
              soundButton.setAttribute('aria-pressed', String(!video.muted));
              soundButton.setAttribute('aria-label', video.muted ? 'הפעלת קול' : 'השתקת הסרטון');
            }
          });
          if (this.observer) this.observer.observe(video);
        });
      }
      ensureLoopCapacity() {
        if (!this.infinite || !this.originalCards.length) return false;
        const width = this.originalCards[0].getBoundingClientRect().width;
        if (!width || !this.track.clientWidth) return false;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.step = width + gap;
        // Enough off-screen cards on both sides, including when only 2 reviews exist.
        const minimum = Math.ceil(this.track.clientWidth / this.step) * 3 + 6;
        const target = Math.ceil(minimum / this.originalCards.length) * this.originalCards.length;
        let added = false;
        while (this.cards.length < target) {
          // Append a complete cycle in the current cyclic order, even after recycling.
          for (let i = 0; i < this.originalCards.length; i++) {
            const source = this.cards[i];
            const clone = source.cloneNode(true);
            const suffix = `-copy-${++this.cloneSerial}`;
            clone.dataset.clone = 'true';
            clone.removeAttribute('data-block-id');
            clone.removeAttribute('data-shopify-editor-block');
            clone.removeAttribute('data-shopify-editor-section');
            clone.setAttribute('aria-hidden', 'true');
            const ids = new Map();
            [clone, ...clone.querySelectorAll('[id]')].forEach(node => {
              if (node.id) { ids.set(node.id, node.id + suffix); node.id += suffix; }
            });
            clone.querySelectorAll('[aria-controls], [aria-labelledby], [aria-describedby]').forEach(node => {
              ['aria-controls', 'aria-labelledby', 'aria-describedby'].forEach(attr => {
                const value = node.getAttribute(attr);
                if (value) node.setAttribute(attr, value.split(/\s+/).map(id => ids.get(id) || id).join(' '));
              });
            });
            clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(node => node.setAttribute('tabindex', '-1'));
            this.track.appendChild(clone); this.cards.push(clone); added = true;
          }
        }
        return added;
      }
      normalizeLoop() {
        if (!this.infinite || !this.step || !this.track.clientWidth) return false;
        const guard = Math.ceil(this.track.clientWidth / this.step) + 1;
        const lower = guard * this.step;
        const upper = this.track.scrollWidth - this.track.clientWidth - lower;
        if (upper < lower) return false;
        const offset = Math.max(0, this.rtl ? -this.track.scrollLeft : this.track.scrollLeft);
        let moves = 0;
        if (offset < lower - 1) moves = Math.ceil((lower - offset) / this.step);
        else if (offset > upper + 1) moves = -Math.ceil((offset - upper) / this.step);
        if (!moves) return false;
        this.track.classList.add('is-shifting');
        for (let i = 0; i < Math.abs(moves); i++) {
          const card = moves > 0 ? this.track.lastElementChild : this.track.firstElementChild;
          const video = card.querySelector('video');
          if (video) { this.visibleVideos.delete(video); video.pause(); video.muted = true; }
          if (moves > 0) this.track.insertBefore(card, this.track.firstElementChild);
          else this.track.appendChild(card);
        }
        this.cards = Array.from(this.track.querySelectorAll('[data-card]'));
        const target = offset + moves * this.step;
        this.track.scrollLeft = this.rtl ? -target : target;
        if (this.shiftFrame) cancelAnimationFrame(this.shiftFrame);
        this.shiftFrame = requestAnimationFrame(() => {
          this.shiftFrame = null; this.track.classList.remove('is-shifting');
        });
        return true;
      }
      playVideo(video) {
        if (this.hold && this.hold.video === video) return;
        const result = video.play();
        if (result && result.catch) result.catch(() => {});
      }
      syncVideos() {
        this.videos.forEach(video => {
          const requested = this.manualPlaying.has(video);
          const automatic = this.dataset.autoplay === 'true' && !this.motionPaused && !this.manualPaused.has(video);
          const visible = this.visibleVideos.has(video) || (!this.observer && requested);
          const held = this.hold && this.hold.video === video;
          if (!held && !document.hidden && visible && (requested || automatic)) this.playVideo(video);
          else video.pause();
        });
      }
      measure() {
        if (this.ensureLoopCapacity()) this.bindCardControls();
        this.normalizeLoop();
        const rect = this.track.getBoundingClientRect();
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const current = Math.abs(this.track.scrollLeft);
        const points = [0];
        this.cards.forEach(card => {
          const c = card.getBoundingClientRect();
          const offset = this.rtl ? rect.right - c.right : c.left - rect.left;
          const value = Math.min(max, Math.max(0, Math.round(current + offset)));
          if (Math.abs(value - points[points.length - 1]) > 2) points.push(value);
        });
        if (max - points[points.length - 1] > 2) points.push(max);
        this.positions = points;
        if (this.dots && this.dots.children.length !== points.length) {
          this.dots.replaceChildren(...points.map((value, index) => {
            const button = document.createElement('button');
            button.type = 'button'; button.className = 'lugc__dot'; button.dataset.page = String(index);
            button.setAttribute('aria-label', `עמוד ביקורות ${index + 1}`);
            return button;
          }));
        }
        this.querySelectorAll('[data-read-more]').forEach(button => {
          const text = button.parentElement.querySelector('[data-review]');
          button.hidden = !text.classList.contains('is-expanded') && text.scrollHeight <= text.clientHeight + 2;
        });
        this.updateNavigation();
      }
      currentIndex() {
        const offset = Math.abs(this.track.scrollLeft);
        return this.positions.reduce((best, point, index) => Math.abs(point - offset) < Math.abs(this.positions[best] - offset) ? index : best, 0);
      }
      updateNavigation() {
        const index = this.currentIndex(), multiple = this.positions.length > 1 && !this.infinite;
        if (this.prev) { this.prev.disabled = index === 0; this.prev.hidden = !multiple; }
        if (this.next) { this.next.disabled = index === this.positions.length - 1; this.next.hidden = !multiple; }
        if (this.dots) {
          this.dots.hidden = !multiple;
          Array.from(this.dots.children).forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
        }
        this.counter.hidden = !multiple || !!this.dots;
        this.counter.textContent = `${index + 1} / ${this.positions.length}`;
      }
      navigate(delta) { this.autoSuspended = true; this.measure(); this.goTo(this.currentIndex() + delta); }
      goTo(index) {
        const target = this.positions[Math.max(0, Math.min(this.positions.length - 1, index))];
        this.track.scrollTo({ left: this.rtl ? -target : target, behavior: this.mediaQuery.matches ? 'auto' : 'smooth' });
      }
      disconnectedCallback() {
        this.releaseHold(false, false);
        clearTimeout(this.bootTimer); this.bootTimer = null;
        if (this.controller) this.controller.abort();
        if (this.observer) this.observer.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.timer) clearInterval(this.timer);
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.shiftFrame) cancelAnimationFrame(this.shiftFrame);
        clearTimeout(this.settleTimer);
        if (this.videos) this.videos.forEach(video => video.pause());
        if (this.track) {
          this.track.querySelectorAll('[data-clone]').forEach(card => card.remove());
          if (this.originalCards) this.originalCards.forEach(card => this.track.appendChild(card));
          this.track.classList.remove('is-dragging', 'is-shifting');
          this.track.scrollLeft = 0;
        }
        this.drag = null; this.pointerDown = false;
        this.activePointerId = null;
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
